'use strict';

angular.module('app.resetPassword')
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('landing.resetPassword', {
                url: '/resetPassword/:param',
                templateUrl: 'app/resetPassword/resetPassword.html?app_v=deployDate',
                controller: 'ResetPasswordCtrl',
                data: {
                    authorizedRoles: []
                }
            })
    }]);